<div class="container-fluid">
    <div class="card" style="margin:5% auto; width: 55%; height:50%">
        <div class="card-data">

            <h5 class="text-center">
                <span class="opensans-semi-bold-sapphire-30px">
                    Update User details
                </span>
            </h5>
            <div class="row">
                <!-- <div class="col-md-12" *ngIf="authWebService.isLoading">
  <app-busy [message]="message"></app-busy>
</div> -->

                <!--   <div class="col-md-12">
  <h3 style="margin-top:0;padding-top:0">
    Ammend User
  </h3>
</div> -->

                <div class="col-md-12" style="margin-bottom:5px;margin-top:5px">
                    <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" autocomplete="off">
                        <div class="row">

                            <div class="form-group col-md-6">
                                <label>First name</label>
                                <input type="text" name="FirstName" id="FirstName" autocomplete="off" formControlName="FirstName" class="form-control input-sm" [disabled]="isadminuser" [ngClass]="{'error': form.controls.FirstName.invalid  && form.controls.FirstName.dirty , 'noerror': form.controls.FirstName.valid  && form.controls.LastName.dirty}"
                                />
                                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.FirstName.invalid && form.controls.FirstName.dirty">
                                    <p *ngIf="form.controls.FirstName.errors.required">*Required</p>
                                    <p *ngIf="form.controls.FirstName.errors.pattern">*First Name entered is invalid</p>
                                </div>
                            </div>

                            <div class="form-group col-md-6">
                                <label>Last name</label>
                                <input type="text" name="LastName" id="LastName" formControlName="LastName" autocomplete="off" [disabled]="isadminuser" class="form-control input-sm" [ngClass]="{'error': form.controls.LastName.invalid  && form.controls.LastName.dirty , 'noerror': form.controls.LastName.valid  && form.controls.LastName.dirty}"
                                />
                                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.LastName.invalid && form.controls.LastName.dirty">
                                    <p *ngIf="form.controls.LastName.errors.required">*Required</p>
                                    <p *ngIf="form.controls.LastName.errors.pattern">*Last Name entered is invalid</p>
                                </div>
                            </div>

                            <div *ngIf="isadminuser === false" class="form-group col-md-6">
                                <label>Mobile Number</label>
                                <!-- <input type="text" name="MobileNumber"    formControlName="MobileNumber" class="form-control input-sm" [ngClass]="{'error': form.controls.MobileNumber.invalid  && form.controls.MobileNumber.dirty , 'noerror': form.controls.MobileNumber.valid  && form.controls.MobileNumber.dirty}" /> -->
                                <ngx-intl-tel-input [cssClass]="'form-control input-sm'" id="MobileNumber" [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                    [selectFirstCountry]="false" [maxLength]="15" [tooltipField]="TooltipLabel.Name" [phoneValidation]="true" [selectedCountryISO]="defaultCountry" [separateDialCode]="separateDialCode" (countryChange)="ChangeCountry($event)"
                                    name="MobileNumber" formControlName="MobileNumber" [disabled]="isadminuser" #MobileNumber>
                                </ngx-intl-tel-input>
                                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.MobileNumber.invalid && form.controls.MobileNumber.dirty">
                                    <p *ngIf="form.controls.MobileNumber.errors.required">*Required</p>
                                    <p *ngIf="form.controls.MobileNumber.errors && !form.controls.MobileNumber.errors.required">*Invalid mobile number</p>
                                </div>
                            </div>

                            <div *ngIf="isadminuser === false" class="form-group col-md-6">
                                <label>Phone number</label>
                                <!-- <input type="text" name="PhoneNumber"  formControlName="PhoneNumber" class="form-control input-sm"  /> -->
                                <!-- <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.PhoneNumber.invalid && form.controls.PhoneNumber.dirty">
            <p *ngIf="form.controls.PhoneNumber.errors.required">*Required</p>
            <p *ngIf="form.controls.PhoneNumber.errors.maxLength">*Invalid phone number</p>
          </div> -->
                                <ngx-intl-tel-input [cssClass]="'form-control input-sm'" [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                    [selectFirstCountry]="false" [maxLength]="15" [tooltipField]="TooltipLabel.Name" [phoneValidation]="true" [separateDialCode]="separateDialCode" [selectedCountryISO]="defaultCountryPhone" (countryChange)="ChangeCountryPhone($event)"
                                    name="PhoneNumber" formControlName="PhoneNumber" [disabled]="isadminuser" #PhoneNumber>
                                </ngx-intl-tel-input>
                                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.PhoneNumber.invalid && form.controls.PhoneNumber.dirty">
                                    <p *ngIf="form.controls.PhoneNumber.errors.required">*Required</p>
                                    <p *ngIf="form.controls.PhoneNumber.errors && !form.controls.PhoneNumber.errors.required">*Invalid phone number</p>
                                </div>
                            </div>

                            <div class="form-group col-md-6">
                                <label>Email</label>
                                <input type="email" name="EmailAddress" autocomplete="off" id="EmailAddress" formControlName="EmailAddress" [disabled]="isadminuser" class="form-control input-sm" [ngClass]="{'error': form.controls.EmailAddress.invalid  && form.controls.EmailAddress.dirty , 'noerror': form.controls.EmailAddress.valid  && form.controls.EmailAddress.dirty}"
                                    disabled/>
                                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.EmailAddress.invalid && form.controls.EmailAddress.dirty">
                                    <p *ngIf="form.controls.EmailAddress.errors.required">*Required</p>
                                    <p *ngIf="form.controls.EmailAddress.errors.pattern">*Invalid Email Address!</p>
                                </div>
                            </div>

                            <div class="form-group col-md-6" *ngIf="aUser.Authenticator === 'AuthWeb'">
                                <label>Username</label>
                                <input type="email" name="UserName" id="UserName" autocomplete="off" formControlName="UserName" [disabled]="isadminuser" class="form-control input-sm" [ngClass]="{'error': form.controls.UserName.invalid  && form.controls.UserName.dirty , 'noerror': form.controls.UserName.valid  && form.controls.UserName.dirty}"
                                    disabled/>
                                <!-- <div class="form-control-feedback text-danger text-small">
                  <p *ngIf="form.controls.UserName.errors.required">*Required</p>
                </div> -->
                            </div>

                            <div class="form-group col-md-6">
                                <label>Preferred Communication Method</label>
                                <select name="CommunicationType" formControlName="CommunicationType" id="CommunicationType" autocomplete="off" [disabled]="isadminuser" class="form-control input-sm" [ngClass]="{'error': form.controls.CommunicationType.invalid  && form.controls.CommunicationType.dirty , 'noerror': form.controls.CommunicationType.valid  && form.controls.CommunicationType.dirty}">
                            <option>SMS</option>
                            <option>EMAIL</option>
                            </select>

                                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.CommunicationType.invalid ">
                                    <p *ngIf="form.controls.CommunicationType.errors.required">*Required</p>
                                </div>
                            </div>

                            <div class="form-group col-md-6" style="display: none;">
                                <label>Role</label>
                                <select name="role" formControlName="role" id="role" [(ngModel)]="selectedId" (change)="checked()" class="form-control form-control-sm">
                                    <option *ngFor="let r of Roles" [value]="r.Id">{{r.Description}}</option>
                                </select>

                                
                                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.role.invalid ">
                                    <p *ngIf="form.controls.role.errors.required">*Required</p>
                                </div>
                            </div>

                            <!-- <div class="form-group col-md-6">
                                <label>Role</label>
                                <select name="role" formControlName="role" id="role" autocomplete="off" [(ngModel)]="selectedRole" [disabled]="isadminuser" class="form-control input-sm" [ngClass]="{'error': form.controls.role.invalid  && form.controls.CommunicationType.dirty , 'noerror': form.controls.role.valid  && form.controls.role.dirty}">
                                    <ng-container >
                                        <option *ngFor="let r of Roles" [ngValue]="r" selected="r.ID == selectedRole.ID">{{r.Description}}</option>
                                    </ng-container>
                            </select>

                                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.role.invalid ">
                                    <p *ngIf="form.controls.role.errors.required">*Required</p>
                                </div>
                            </div> -->


                            <div class="form-group col-md-6" *ngIf="aUser.Authenticator === 'AuthWeb'">
                                <label>Need to Change Password?</label>
                                <button class="btn btn-sm btn-default" routerLink="/reset"><i class="fa fa-key"
                  style="margin-right:5px"></i>Reset Password</button>
                            </div>

                            <div class="form-group col-md-6" *ngIf="(aUser.Authenticator === 'Google' || aUser.Authenticator === 'Facebook') && ssoupdate == true">
                                <input type="checkbox" name="terms-check" value="1" ([ngModel])="terms" [checked]="terms=='1'" [disabled]="isadminuser" (click)="ckeckTerms($event)" /> By clicking the checkbox, you note our
                                <a href="#" data-toggle="modal" data-target="#POPIAAmend">POPIA Processing Notices</a>
                            </div>

                            <div class="form-group col-md-12">
                                <!-- <pre><code>{{ getAllErrors(form) | json }}</code></pre> -->

                                <button class="btn btn-sm btn-primary" *ngIf="isadminuser === false" [disabled]="!form.valid" id="SaveButton"><i class="fa fa-save"
                    style="margin-right:5px" ></i>Update</button>
                                <button class="btn btn-sm btn-default" (click)="cancelupdate()"><i class="fa fa-undo"
                    style="margin-right:5px"></i>Close</button>

                            </div>

                        </div>
                    </form>
                </div>

            </div>

        </div>
    </div>

</div>

<button data-toggle="modal" data-target="#addEdit" id="secretButton" style="display:none"><i class="fa fa-save"></i>Save</button>

<div class="modal fade form-group" id="addEdit" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <label class="text-center title">Enter verification code</label>
                <button type="button" class="close" data-dismiss="modal" id="closeButton" (click)="close()" #closebutton aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body modal-xl">
                <form>

                    <div class="row test">
                        <div class="col-12 sp-fld">
                            <div class="text-center">
                                <p id="OtpMessage"></p>
                            </div>
                            <input class="form-control input-sm text-center" type="number" id="OTPCode" maxlength="6" />
                            <p class="alert-warning text-center" id="Attempts">You have 3 attempts left</p>
                        </div>
                    </div>
                    <div class="modal-footer">

                        <button type="button" class="btn btn-primary btn-block mt-4 mb-4" (click)="verifyOtp()">Confirm</button>
                    </div>
                </form>
            </div>
        </div>

    </div>
</div>

<div class="modal fade" id="POPIAAmend" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">

    <div class="modal-dialog modal-lg" role="document" style="width: 100% !important;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">POPIA Processing Notices</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body modal-lg">

                <div class="clearfix section  pb-8 text-gray">
                    <div class="">
                        <div class="bg-transparent matrix-copy 1 1 normal ">
                            <div class="mb-0-lastchild  ">
                                <h3 class="text-blue font-weight-semi-bold">Background to data privacy in South Africa</h3>
                                <p><br>The Protection of Personal Information Act, 4 of 2013, (“POPIA”), which came into force on 1 July 2021, is a law which regulates the use and processing of a person and / legal entity’s personal information, this being
                                    in response to, and in order to protect and give effect to a person and/or legal entity’s rights to privacy, including the right not to have their / its personal information and related data misused, abused or used
                                    for ulterior purposes.</p>
                                <p>POPIA applies to personal information which belongs to individuals and legal entities (“Data Subjects”) which is processed, be it in an automated or non-automated manner in South Africa, by another (“Responsible Party”)
                                    and places on any Responsible Party who is processing a data Subject’s personal information, a duty to use it lawfully and only for a specific and defined purpose(s).</p>
                                <p>In terms of POPIA, Cross Border Road Transport Agency (C-BRTA) , as a Responsible Party, is required to appoint an Information Officer (“IO”) and Deputy Information Officers (“DIOs”), to be responsible for establishing
                                    a POPIA Compliance Framework, and who following this, are required to assess, analyse and understand what types of personal information C-BRTA is processing which belongs to Data Subjects and to thereafter develop certain
                                    processes and procedures, including a POPIA Policy, which have to be followed by all C-BRTA employees when they process and use another’s personal information.</p>
                                <p>A Personal Information Impact Assessment as per the C-BRTA’s POPIA Compliance Framework has been carried out and created, which has indicated that C-BRTA , during the course of its business activities does and will continue
                                    to collect, store and process personal information about C-BRTA employees, its customers, suppliers and other third parties.</p>
                                <p>Furthermore, the Impact Assessment has defined and revealed that C-BRTA processes a large amount of different types of personal information including names, addresses, opinions, financial details, medical details and the
                                    like which pertain to current, past and prospective employees and customers, suppliers, and others who C-BRTA communicates and deals with and which processing is carried out for a variety of purposes, including for
                                    business, compliance and legal purposes.</p>
                                <p>C-BRTA also processes special purpose information including gender, sex, marital status, colour, age, race or ethnic origin, religious beliefs, trade union membership and the like for the purposes of recruitment, employment
                                    equity statistics, legal compliance and for the facilitation of union fees and memberships.</p>
                                <p>Following the Personal Information Impact Assessment, C-BRTA is confident that whilst this personal information is held on paper or on a computer or other media, such storage is subject to the prescribed legal safeguards
                                    as specified in POPIA and other regulations.</p>
                                <p>As per the POPIA requirements has implemented a robust POPIA compliance programme which includes various POPIA policies and processes, some of which are internal documents and some are which are available for public access.
                                    These documents are available for public access and can be accessed in the menu on the left.<br></p>
                                <p><br></p>
                            </div>
                        </div>
                    </div>
                </div>





            </div>
            <div class="modal-footer">

                <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2 myButton" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>


</div>